export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientAccompanyingSymptomByIdFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientAccompanyingSymptomById', id).then(() => {
        if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientAccompanyingSymptomModule.patientAccompanyingSymptom;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAccompanyingSymptomModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
                this.getPatientAccompanyingSymptomByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientAccompanyingSymptomFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientAccompanyingSymptom', id).then(() => {
        if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp =
            this.$store.state.patientAccompanyingSymptomModule.allPatientAccompanyingSymptom;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAccompanyingSymptomModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
                this.getAllPatientAccompanyingSymptomFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientAccompanyingSymptomFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientAccompanyingSymptom', data).then(() => {
        if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.getAllPatientAccompanyingSymptomFunction(this.patientId);
            this.patientAccompanyingSymptomTrumaTypeAdded();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAccompanyingSymptomModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
                this.addPatientAccompanyingSymptomFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePatientAccompanyingSymptomFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      let id = null;
      if (data?.id) {
        id = data.id;
      } else {
        id = data;
      }
      this.$store.dispatch('deletePatientAccompanyingSymptom', id).then(() => {
        if (this.$store.state.patientAccompanyingSymptomModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            // if (this.missionType == 'truma') {
            if (this.localFlagShowForm == 3) {
              this.removeItem(data.title);
            }
            this.getAllPatientAccompanyingSymptomFunction(this.patientId);
          }
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientAccompanyingSymptomModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePatientAccompanyingSymptomFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientAccompanyingSymptomModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
